import React from 'react';
import PropTypes from 'prop-types';

export default function JobCurrentIcon({ width, height }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.386 9.355l-1.795-.4c-.253-.047-.483-.212-.667-.423-1.841-2.353-2.186-2.494-2.67-2.518l-1.726-.117c-.253-.024-.552-.024-2.992.94a3.276 3.276 0 00-1.495 1.2l-1.335 2a.864.864 0 00-.161.4 1.022 1.022 0 00-1.013.494l-.23.377-.805-.494c-.254-.165-.599-.07-.76.188L3.08 13.778a.58.58 0 00.184.776l4.258 2.612c.253.164.598.07.76-.189l1.656-2.776a.58.58 0 00-.184-.776l-.805-.494.23-.376c.207-.33.184-.73 0-1.059.092-.07.184-.165.276-.259l1.335-2c.138-.188.322-.329.529-.423.207-.07.368-.141.552-.212l-.805 2.823a3.425 3.425 0 00.391 2.8l4.925 8.187a1.2 1.2 0 001.013.588c.23 0 .437-.047.644-.188.575-.353.736-1.106.391-1.694l-4.004-6.564 1.657-4.94c.069.094.138.165.207.259a3.181 3.181 0 001.864 1.176l1.795.4a1.037 1.037 0 001.243-.823 1.102 1.102 0 00-.806-1.27zm-8.945 7.022l1.493 2.532-1.152 3.323c-.17.474-.597.768-1.045.768-.128 0-.256-.023-.384-.068-.576-.226-.874-.904-.661-1.514l1.749-5.04zm-4.009-4.946l1.008.51c.078.02.104.148.052.233l-.258.34-1.37-.68.258-.34c.052-.084.207-.105.31-.063zm4.98-8.339a2.33 2.33 0 012.563-2.078 2.34 2.34 0 012.06 2.586 2.33 2.33 0 01-2.563 2.078 2.34 2.34 0 01-2.06-2.586z" />
    </svg>
  );
}

JobCurrentIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

JobCurrentIcon.defaultProps = {
  width: 24,
  height: 24,
};

